<template>
	<div class="home-page" id="homePage" ref="homepage">
		<div class="moving-head" :style="{ top: isShowMovingHead + 'px' }">
			<div class="header-content">
				<div class="left-box">
					<img src="../../assets/images/logo.png" height="30" @click="goHome()" />
				</div>
				<div class="center-box">
					<div class="search-box">
						<el-input v-model="searchKey" maxlength="50" placeholder="搜索商品名称"></el-input>
						<div class="search-icon" @click="search()">
							<i slot="prefix" class="el-input__icon el-icon-search"></i>
						</div>
					</div>
				</div>
				<div class="right-box" @click="goCart()" v-if="
            !hasLogin || (userInfo && userInfo.enterpriseType != 'SALESMAN')
          ">
					<div class="img-box">
						<img src="../../assets/images/chat.png" width="16" height="17" />
					</div>
					<div class="text">我的购物车</div>
				</div>
			</div>
		</div>

		<div class="header-box">
			<div class="top-box" :style="{
          'padding-bottom': routeMeta.parent !== 'mycenter' ? '0' : '30px',
        }">
				<div class="left-box">
					<img src="../../assets/images/logo.png" height="36" @click="goHome()" />
				</div>
				<div class="center-box">
					<div class="search-box">
						<el-input v-model="searchKey" maxlength="50" placeholder="搜索商品名称"></el-input>
						<div class="search-icon" @click="search()">
							<i slot="prefix" class="el-input__icon el-icon-search"></i>
						</div>
					</div>
					<div class="hot-search">
						<div class="label" v-for="item in hotWords" @click="search(item.name)" :key="item.id">
							{{ item.name }}
						</div>
					</div>
				</div>
				<div class="right-box" @click="goCart()" v-if="
            !hasLogin || (userInfo && userInfo.enterpriseType != 'SALESMAN')
          ">
					<div class="img-box">
						<img src="../../assets/images/chat.png" width="16" height="17" />
					</div>
					<div class="text">我的购物车</div>
				</div>
			</div>
			<div class="bottom-box" v-if="routeMeta.parent !== 'mycenter'">
				<div class="left-box">
					<div class="icon-box">
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
					<div class="title">全部商品分类</div>
					<div class="menu-type-box">
						<type-components></type-components>
					</div>
				</div>
				<div class="right-box">
					<el-tabs v-model="tabName" @tab-click="tabClick">
						<el-tab-pane label="健康首页" name="home"></el-tab-pane>
						<!-- <el-tab-pane label="领券中心" name="coupon"></el-tab-pane> -->
						<el-tab-pane label="急速下单" name="order"></el-tab-pane>
						<el-tab-pane label="限时抢购" name="panicBuying"></el-tab-pane>
						<el-tab-pane label="新品收集" name="newGather"></el-tab-pane>
						<el-tab-pane label="领券中心" name="coupon"></el-tab-pane>
					</el-tabs>
					<div class="btn-box" v-if="key == '/cart'">
						<el-button size="small" class="download-btn" icon="el-icon-download" plain
							@click="downloadClick()">下载导入模板</el-button>
						<el-button size="small" class="import-btn" icon="el-icon-upload2" plain
							@click="importBtnClick()" :loading="importLoading">订单商品导入</el-button>
						<input class="input-file" ref="fileInt" style="display: none" type="file" @change="importChange"
							accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
					</div>
				</div>
			</div>
		</div>
		<div class="home-main-content-box">
			<transition name="fade-transform" mode="out-in">
				<router-view :key="key" />
			</transition>
		</div>
	</div>
</template>

<script>
	import {
		getHtWords,
		importCartData
	} from "@/api/goods.js";
	import typeComponents from "@/components/typeComponents.vue";
	import {
		mapGetters
	} from "vuex";
	import XLSX from "xlsx";

	export default {
		name: "homepage",
		components: {
			typeComponents,
		},
		computed: {
			...mapGetters(["vuex_searchKey", "userInfo", "hasLogin"]),

			key() {
				if (
					!this.$route.meta ||
					(this.$route.meta && this.$route.meta.parent !== "mycenter")
				) {
					return this.$route.path;
				}
			},
		},
		// 滚动监听
		mounted() {
			window.addEventListener("scroll", this.handleScroll); // 监听页面滚动
		},
		watch: {
			vuex_searchKey(val) {
				if (!this.flag) {
					this.searchKey = val;
					this.storeFlag = true;
				}
				this.flag = false;
			},
			searchKey(val) {
				if (!this.storeFlag) {
					this.$store.commit("SET_SEARCHKEY", val);
					this.flag = true;
				}
				this.storeFlag = false;
			},
			$route: {
				handler(val) {
					if (val.meta) {
						this.routeMeta = val.meta;
					}

					if (val.path == "/home") {
						this.tabName = "home";
					} else if (val.path == "/coupon") {
						this.tabName = "coupon";
					} else if (
						val.path == "/goodsList" &&
						val.query &&
						val.query.pageFrom == "quickOrder"
					) {
						this.tabName = "order";
					} else if (val.path == "/home/newGather") {
						this.tabName = "newGather";
					} else if (val.path == "/coupon") {
						this.tabName = "coupon";
					} else if (val.path == "/panicBuying") {
						this.tabName = "panicBuying";
					} else {
						this.tabName = "";
					}
				},
				immediate: true,
			},
		},
		data() {
			return {
				searchKey: "",
				searchClickNum: 0,
				tabName: "home",
				hotWords: [],
				isShowMovingHead: -64,
				routeMeta: {},
				importLoading: false,
			};
		},
		beforeMount() {
			this.getHtWords();
		},
		methods: {
			// 获取页面滚动距离
			handleScroll() {
				let scrollTop =
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop;
				this.isShowMovingHead = scrollTop - 200 > 0 ? 0 : scrollTop - 200;
			},

			getHtWords() {
				getHtWords().then((res) => {
					if (res && res.code == 0 && res.data && res.data.records) {
						this.hotWords = res.data.records;
					}
				});
			},

			tabClick(tab, event) {
				if (this.tabName === "home") {
					this.$router.replace("/home");
				} else if (this.tabName === "coupon") {
					this.$router.replace("/coupon");
				} else if (this.tabName === "order") {
					this.searchKey = "";
					if (this.hasLogin) {
						this.$router.replace("/goodsList?pageFrom=quickOrder");
					} else {
						this.$router.push('/login?redirect=' + this.$route.fullPath);
					}
				} else if (this.tabName === "newGather") {
					this.$router.replace("/home/newGather");
				} else if (this.tabName === "coupon") {
					this.$router.replace("/coupon");
				} else if (this.tabName === "panicBuying") {
					this.$router.replace("/panicBuying");
				}
			},

			search(key) {
				this.searchClickNum++;

				if (key) {
					this.searchKey = key;
				}

				if (this.searchKey && this.searchKey != "") {
					this.tabName = "";
					this.$router.push("/goodsList?pageFrom=search");
				}
			},

			/**
			 * 2023-11-13 DH
			 * 下载导入模板
			 * */
			downloadClick() {
				var url =
					process.env.VUE_APP_BASE_UI + "/ImportTemplate/订单商品导入模板.xlsx";
				window.open(url);
			},

			/**
			 * 2023-11-13 DH
			 * 导入订单商品按钮点击事件
			 * */
			importBtnClick() {
				document.querySelector(".input-file").click();
			},

			/**
			 * 2023-11-13 DH
			 * 导入订单商品
			 * */
			importChange(event) {
				if (event.currentTarget == null || !event.currentTarget.files.length) {
					this.$message.error("导入失败");
					return;
				}

				const self = this;
				// 拿取文件对象
				let f = event.currentTarget.files[0];
				// 用FileReader来读取
				let reader = new FileReader();
				// 重写FileReader上的readAsBinaryString方法
				FileReader.prototype.readAsBinaryString = function(f) {
					let binary = "";
					let wb; // 读取完成的数据
					let outdata; // 你需要的数据
					let reader = new FileReader();
					reader.onload = function(e) {
						// 读取成Uint8Array，再转换为Unicode编码（Unicode占两个字节）
						let bytes = new Uint8Array(reader.result);
						let length = bytes.byteLength;
						for (let i = 0; i < length; i++) {
							binary += String.fromCharCode(bytes[i]);
						}
						// 接下来就是xlsx了，具体可看api
						wb = XLSX.read(binary, {
							type: "binary",
						});
						outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);

						// 自定义方法向父组件传递数据
						let changeList = [];
						if (outdata && outdata.length > 0) {
							for (let i = 0; i < outdata.length; i++) {
								if (!outdata[i].packing && !outdata[i].pieces) {
									self.$refs.fileInt.value = "";
									self.$message.error("请填写商品数量");
									return false;
								}

								let packing = 0;
								let pieces = 0;

								if (outdata[i].packing) {
									// 数值向下取整如果与原数值相等，则为整数，否则报错
									if (Math.floor(outdata[i].packing) == outdata[i].packing) {
										packing = parseInt(outdata[i].packing);
									} else {
										self.$refs.fileInt.value = "";
										self.$message.error("请填写正确的中包装数量");
										return false;
									}
								}

								if (outdata[i].pieces) {
									if (Math.floor(outdata[i].pieces) == outdata[i].pieces) {
										pieces = parseInt(outdata[i].pieces);
									} else {
										self.$refs.fileInt.value = "";
										self.$message.error("请填写正确的件装数量");
										return false;
									}
								}

								let changeData = {
									productType: outdata[i].productTypeCode,
									packing: packing,
									pieces: pieces,
								};
								changeList.push(changeData);
							}
							self.$refs.fileInt.value = "";
							self.importLoading = true;
							self.importCartData(changeList);
						} else {
							self.$refs.fileInt.value = "";
							self.$message.error("操作失败");
						}
					};
					reader.readAsArrayBuffer(f);
				};
				reader.readAsBinaryString(f);
			},

			/**
			 * 2023-11-14 DH
			 * 导入数据
			 * */
			async importCartData(data) {
				let res = await importCartData(data);
				this.importLoading = false;

				if (res && res.code == 0) {
					this.$message.success("导入成功");
				} else {
					this.$message.error(res && res.msg ? res.msg : "导入失败");
				}
			},

			goCart() {
				this.$router.push("/cart");
			},

			goHome() {
				this.$router.replace("/home");
			},
		},
	};
</script>

<style lang="scss" rel="stylesheet/scss">
	@import "@/assets/css/szui.scss";

	.home-page {
		overflow: hidden;
		// @keyframes fade-in {
		// 	from {
		// 		top: -64px;
		// 		opacity: 0;
		// 	}

		// 	to {
		// 		top: 0;
		// 		opacity: 1;
		// 	}
		// }

		.moving-head {
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			z-index: 1000;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			width: calc(100vw - 4px);
			height: 64px;
			background: #ffffff;
			box-shadow: 0px 40px 90px 0px rgba(38, 39, 40, 0.05);
			opacity: 1;
			animation-name: fade-in;
			animation-duration: 0.5s;

			.header-content {
				align-items: center;

				.left-box {
					cursor: pointer;
				}

				.center-box {
					margin-left: 82px;

					.search-box {
						height: 36px;

						.el-input {
							height: 36px;

							.el-input__inner {
								height: 36px;
							}
						}

						.search-icon {
							height: 36px;
						}
					}
				}

				.right-box {
					height: 36px;
				}
			}
		}

		.moving-head,
		.header-box {

			.header-content,
			.top-box {
				display: flex;
				justify-content: flex-start;
				align-items: flex-start;
				margin: 0 auto;
				width: 1240px;
				min-width: 1240px;
				padding: 0 20px;

				.left-box {
					cursor: pointer;
				}

				.center-box {
					margin-left: 54px;

					.search-box {
						display: flex;
						justify-content: center;
						align-items: center;
						width: 700px;
						height: 40px;
						border-radius: 8px;
						overflow: hidden;

						.el-input {
							width: 620px;
							height: 40px;

							.el-input__inner {
								width: 100%;
								height: 40px;
								border: 1px solid $main;
								border-radius: 8px 0px 0px 8px;
								font-size: 13px;
								color: $fontColor;
							}
						}

						.search-icon {
							display: flex;
							justify-content: center;
							align-items: center;
							width: 80px;
							height: 40px;
							background: $main;
							border-radius: 0px 8px 8px 0px;
							cursor: pointer;

							.el-icon-search {
								font-weight: bold;
								font-size: 16px;
								color: $fontColor;
							}
						}
					}

					.hot-search {
						display: flex;
						justify-content: flex-start;
						align-items: center;
						margin-top: 10px;
						font-size: 13px;
						color: #606366;

						.label {
							margin-right: 10px;
							cursor: pointer;
						}

						.label:hover {
							text-decoration: underline;
						}
					}
				}

				.right-box {
					display: flex;
					justify-content: center;
					align-items: center;
					margin-left: 10px;
					width: 120px;
					height: 40px;
					border: 1px solid #c0c4cc;
					border-radius: 8px;
					cursor: pointer;
					font-size: 14px;
					color: $fontColor;

					.img-box {
						width: 16px;
						height: 18px;
					}

					.text {
						margin-left: 6px;
					}
				}

				.right-box:hover {
					border: 1px solid $main;
					background-color: rgba(255, 204, 0, 0.1);
				}
			}
		}

		.header-box {
			padding-top: 38px;
			width: 100%;
			background-color: #ffffff;

			.bottom-box {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				margin: 10px auto 0;
				width: 1240px;
				min-width: 1240px;
				padding: 0 20px;

				.left-box {
					position: relative;
					display: flex;
					justify-content: flex-start;
					align-items: center;
					padding-left: 20px;
					width: 230px;
					height: 50px;
					background: $main;
					border-radius: 10px 10px 0px 0px;
					cursor: pointer;

					.icon-box {
						display: flex;
						justify-content: space-between;
						align-items: center;
						flex-wrap: wrap;
						width: 17px;
						height: 18px;

						div {
							width: 8px;
							height: 8px;
							border: 2px solid $fontColor;
							border-radius: 2px;
						}
					}

					.title {
						margin-left: 8px;
						height: 18px;
						line-height: 18px;
						font-size: 16px;
						color: $fontColor;
					}

					.menu-type-box {
						position: absolute;
						top: 50px;
						left: 0;
						z-index: 10;
						padding-top: 10px;
						background-color: #f8f8f8;
						display: none;
					}
				}

				.left-box:hover {
					.menu-type-box {
						display: block;
					}
				}

				.right-box {
					flex: 1;
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-left: 50px;

					.el-tabs {
						.el-tabs__header {
							margin: 0;

							.el-tabs__nav-wrap::after {
								content: none;
							}

							.el-tabs__item {
								height: 50px;
								line-height: 50px;
								font-size: 18px;
								color: #606366;
							}
						}
					}

					.btn-box {
						display: flex;
						justify-content: flex-end;
						align-items: center;

						.import-btn,
						.download-btn {
							display: flex;
							justify-content: center;
							align-items: center;
							width: 120px;
							height: 40px;
							border: 1px solid #c0c4cc;
							border-radius: 8px;
							cursor: pointer;
							font-size: 14px;
							color: $fontColor;
						}

						.import-btn:hover,
						.download-btn:hover {
							border: 1px solid $main;
							background-color: rgba(255, 204, 0, 0.1);
						}
					}
				}
			}
		}

		.home-main-content-box {
			margin: 10px auto 50px;
			padding: 0 20px;
			width: 1240px;
		}
	}
</style>